import React, { PropsWithChildren, ReactElement } from 'react';
import styled from '@emotion/styled';
import { BsPlus } from '@react-icons/all-files/bs/BsPlus';

import { EditorPlaceholder } from '../../components';

export interface HTMLTemplateProps {
  /** HTML로 된 내용 */
  contents: string;
}

export function HTMLTemplate({ contents }: PropsWithChildren<HTMLTemplateProps>): ReactElement {
  if (!contents) {
    return (
      <EditorPlaceholder
        icon={<BsPlus />}
        message="내용을 추가해주세요."
      />
    );
  }

  return (
    <Template dangerouslySetInnerHTML={{ __html: contents }} />
  );
}

const Template = styled.div`
  * {
    width: 100%;
    display: inherit;
  }
`;
